.spinnerContainer {
  width: 187px;
  display: flex;
  align-items: center;
  justify-content: center;
}
